import { useState } from "react";
import type { SyntheticEvent } from "react";

/**
 * Tracks whether a <video> is waiting on bytes so a spinner can sit over the
 * poster. `autoplay` videos start out buffering; an on-demand player only
 * buffers once someone presses play, because `loadstart` fires on mount even
 * under preload="none" and `canplay` never follows until playback is asked for.
 */
export function useVideoBuffering(autoplay: boolean) {
  const [buffering, setBuffering] = useState(autoplay);
  const stop = () => setBuffering(false);
  const startIfPlaying = (event: SyntheticEvent<HTMLVideoElement>) => {
    if (autoplay || !event.currentTarget.paused) setBuffering(true);
  };
  return {
    buffering,
    handlers: {
      onLoadStart: startIfPlaying,
      onWaiting: startIfPlaying,
      onPlay: () => setBuffering(true),
      onPlaying: stop,
      onCanPlay: stop,
      onSuspend: stop,
      onPause: stop,
      onError: stop,
    },
  };
}
